var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.projectContext.project
    ? _c(
        "side-nav-container",
        { attrs: { title: "Project settings", icon: "cog" } },
        [
          _vm._l(_vm.links, function (link, index) {
            return [
              link.subItems.length > 0
                ? _c(
                    "div",
                    { key: `containerToggle:${link.navigationItemId}` },
                    [
                      _c(
                        "toggle-trigger",
                        {
                          staticClass: "gfu-sidenav__item gfu-sidenav__trigger",
                          attrs: {
                            "container-name": `containerToggle:${link.navigationItemId}`,
                            tag: "div",
                            "auto-collapse": false,
                            "active-class": "gfu-sidenav__trigger--expanded",
                            "data-qa": `admin-project-sidenav-trigger:${link.qa}`,
                          },
                        },
                        [
                          _c("div", { staticClass: "gfu-sidenav__content" }, [
                            _vm._v(_vm._s(link.label)),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "toggle-container",
                        {
                          ref: `containerToggle:${link.navigationItemId}`,
                          refInFor: true,
                          staticClass: "gfu-sidenav__collapsible",
                          attrs: {
                            name: `containerToggle:${link.navigationItemId}`,
                            "show-expanded": link.isExpanded,
                            tag: "div",
                            "active-class":
                              "gfu-sidenav__collapsible--expanded",
                            tabindex: index,
                          },
                        },
                        _vm._l(link.subItems, function (child) {
                          return _c(
                            "side-nav-link",
                            {
                              key: child.label,
                              attrs: {
                                to: child.to,
                                icon: child.iconName,
                                "data-qa": `admin-project-sidenav-link:${child.qa}`,
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(child.label) +
                                  "\n                "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "side-nav-link",
                    {
                      key: link.navigationItemId,
                      attrs: {
                        to: link.to,
                        icon: link.icon.name,
                        "icon-namespace": link.icon.namespace,
                        "data-qa": `admin-project-sidenav-link:${link.qa}`,
                      },
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(link.label) + "\n        "
                      ),
                    ]
                  ),
            ]
          }),
          _vm._v(" "),
          _c("progress-overlay", { attrs: { visible: _vm.isProcessing } }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }